
            import { lazy } from "react";

export const InteractiveButton = lazy(() => import("./InteractiveButton"));

            